import React from 'react';
import LOOKUP from 'constants/lookup';
import Button from 'screens/components/basic/Button';
import SelectInput from 'screens/components/basic/SelectInput';

const componentName = 'ProductCategoriesListBulkTrasfer';
const ProductCategoriesListBulkTrasfer = (props) => {
    return (
        <div className="row">
            <div className="col-xs-12 col-sm-8 col-md-7 col-lg-6 col-xl-10 p-0">
                <SelectInput name={`${componentName}CategoryIdSearch`}
                    label={LOOKUP.product.filters.category.label}
                    floatingLabelText={LOOKUP.product.filters.category.label}
                    hintText={LOOKUP.product.filters.category.hintText}
                    className="smallerPlaceholder"
                    options={props.categoriesList}
                    fullWidth={true}
                />
            </div>
            <div className="col-lg-6 col-md-5 p-0 d-flex align-items-center justify-content-end">
                <Button
                    className="pull-right mb-2 mr-3"
                    primary={true}
                    id="buttonCategorySearch"
                    label={LOOKUP.employee.filters.filterButton}
                    onTouchTap={props.searchProductByCategory} />
                <Button
                    className="pull-right mb-2"
                    id="buttonCategorySelectAll"
                    label={<span style={{ whiteSpace: `nowrap`, color: `white` }}>SELECT ALL</span>}
                    primary={true}
                    onTouchTap={props.selectAllProductsByCategory}
                />
            </div>
        </div>
    )
}

export default ProductCategoriesListBulkTrasfer;